/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { AnnounceService, SeasonDto, TableDto } from 'app/modules/core'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'
import moment from 'moment'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { catchErrorMsg } from 'app/modules/core/helpers/Helper'



const AnnounceBoardPage: FC = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const [data, setData] = useState<TableDto>()
    const [year, setYear] = useState<string>(new Date().getFullYear().toString())
    const navigate = useNavigate()
    useEffect(() => {
        const init = () => {
            AnnounceService.GetBoard(Number(year)).then((result) => {
                const res = result.data.result
                if (res) {
                    setData(res)
                }

            })
        }
        init()
    }, [year])

    const seasonOption = () => {
        const opt: any[] = []
        const yearCnt = new Date().getFullYear()

        for (let index = 0; index < 5; index++) {
            const yearStr = yearCnt - index
            opt.push(<option key={index}
                value={yearStr.toString()}>{yearStr.toString()}</option>)
        }


        return opt;
    }

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className='card mb-5 mb-xl-8 '>
                <div className='card-header cursor-pointer'>
                    <div className='card-title m-0 d-flex flex-column'>
                        <h3 className='fw-bolder p-5'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder p-5 d-flex justify-content-between'><span className='pe-5'>เลือกปี</span> <span>
                            <select className='form-control select' onChange={(e) => e.target?.value && setYear(e.target.value)}
                                value={year}
                            >
                                {seasonOption()}
                            </select>
                        </span></h3>
                    </div>
                </div>
                <div className='card-body py-3' style={{ minHeight: '200px' }}>
                    <table className='table' >
                        <thead >
                            <th className='p-5 fs-4 fw-bolder'>หัวข้อ</th>
                            <th className='p-5 fs-4 fw-bolder'>สถานะ</th>
                            <th className='p-5 fs-4 fw-bolder'>วันที่ประกาศ</th>
                        </thead>
                        <tbody>
                            {data && data.rows.length > 0 ? data.rows.map((item, index) => {
                                return <tr key={index}>
                                    <td className='fs-4'><a href='#/' onClick={(e) => navigate('/announce/' + item[0])} >{item[2]}</a></td>
                                    <td className='fs-4' ><span className={clsx("badge",
                                        { 'bg-warning text-dark': item[3] === 'New' },
                                        { 'bg-success': item[3] === 'Complete' },
                                        { 'bg-danger': item[3] === 'InComplete' },
                                        { 'bg-primary': item[3] === 'Readed' },
                                        { 'bg-danger': item[3] === 'Fail' },
                                        { 'bg-dark' :item[3]==='Expired'}
                                    )}>{item[3]}</span></td>
                                    <td>{item[1]}</td>
                                </tr>
                            }) : <tr><td colSpan={2}>ไม่พบข้อมูล</td></tr>}
                        </tbody>

                    </table>

                </div>

            </div>

        </>
    )
}
export { AnnounceBoardPage }
function setLoading(arg0: boolean) {
    throw new Error('Function not implemented.')
}

